import React, { useState } from 'react';
import MainLayout from '../Layouts/MainLayout';
import FollowUpsByUserId from './FollowUpsByUserId';

function UserFollowUpsList() {
  const [navParams, setNavParams] = useState({
    navTitle: 'User Follow Ups',
    navSubTitle: 'Welcome to ImagesBazaar',
  });

  return (
    <MainLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
    >
      <FollowUpsByUserId />
    </MainLayout>
  );
}

export default UserFollowUpsList;
